"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Web <Type /> relies on base-styles defaults from CSS stylesheet
// so no additional default values are needed in here
//
// This file is merged into the default context value in TypographyContext.jsx
var _default = {};
exports.default = _default;